import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../api.js';
import { useI18n } from '../../i18n/index.jsx';
import { useAuth } from '../../auth.jsx';
import { useLive } from '../../live.jsx';
import RequestCard from './RequestCard.jsx';
import './requests.css';

// Home page: "Dernières demandes d'achat / Latest buying requests" — the
// 6 latest open requests, the ones PME features first. Hidden when none.
export default function LatestRequests() {
  const { t, lang } = useI18n();
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [tick, setTick] = useState(0);
  useLive(['requests'], () => setTick((x) => x + 1));
  useEffect(() => { api(`/buying-requests/latest?lang=${lang}`).then((d) => setItems(d.items)).catch(() => setItems([])); }, [lang, tick]);
  if (!items.length) return null;
  return (
    <section className="section home-requests" aria-labelledby="home-req-h">
      <div className="container">
        <header className="section-head">
          <h2 id="home-req-h"><span className="wanted-badge">{t('buying.wanted')}</span> {t('buying.home.title')}</h2>
          <p className="muted">{t('buying.home.lead')}</p>
        </header>
        <div className="req-grid">{items.map((r) => <RequestCard key={r.id} request={r} />)}</div>
        <p className="req-actions" style={{ justifyContent: 'center', marginTop: 20 }}>
          <Link className="btn btn-primary" to="/marketplace?tab=requests">{t('buying.home.all')}</Link>
          <Link className="btn btn-ghost" to={user ? '/account/buying-requests/new' : '/signup'}>{t('buying.home.post')}</Link>
        </p>
      </div>
    </section>
  );
}
